import { render, staticRenderFns } from "./companyInfo.vue?vue&type=template&id=68bee234&"
import script from "./companyInfo.vue?vue&type=script&lang=ts&"
export * from "./companyInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports